<template>
  <v-container fluid>
    <v-card>
      <v-card-text>
        <v-row>
          <v-container>
            <v-row>
              <v-col cols="12">
                <gg-card-title subtitle class="pt-0 pb-0">Choose Application</gg-card-title>
              </v-col>
            </v-row>
            <data-view cols="4"
                       :items="items"
                       v-model="selection"
            />
          </v-container>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { cardActiveStyle } from '@/helpers/wizard'
import DataView from '@/components/Wizard/DataView'

export default {
  name: 'NewWebsiteAlt',
  components: {
    DataView
  },
  computed: {
    ...mapGetters({
      items: 'wizard/applications_alt',
      selected: 'wizard_model/application'
    }),
    selection: {
      get () {
        return this.selected
      },
      set (val) {
        this.setChoice(val)
      }
    }
  },
  beforeDestroy () {
    // Clear selection before component will be destroyed
    this.selection = undefined
  },
  methods: {
    ...mapMutations({
      setChoice: 'wizard_model/SET_WEBSITE_ALT_CHOICE'
    }),
    cardActiveStyle
  }
}
</script>
